import { isNil } from 'lodash';

export default function getAriaLabelById(
  labelType: 'label' | 'description',
  labelPostfix?: string | number,
  outterLabelId?: string
) {
  const innerLabelId = !isNil(labelPostfix) ? `${labelType}-${labelPostfix}` : '';
  const concatedIds = [innerLabelId, outterLabelId].filter(Boolean).join(' ');

  return concatedIds || undefined;
}
